import { Controller } from "stimulus";

export default class extends Controller {
  static get targets() {
    return ["form"];
  }

  initialize(){
    console.log("modconfig controller initialized");
    this.reactComponentPromise = import("../react/ValheimPlusUserConfigComponent");
  }

  async connect(){
    this.reactComponent = await this.reactComponentPromise;

    const formTarget = this.formTarget;
    const csrfTokenValue = formTarget.getAttribute("csrf-token-value");
    const path = formTarget.getAttribute("path");
    const validationSchema = formTarget.getAttribute("validation-schema");
    const initialValues = formTarget.getAttribute("initial-values");
    const userConfigName = formTarget.getAttribute("valheim-plus-user-config-name");
    const configSelectPath = formTarget.getAttribute("config-select-path");
    const action = formTarget.getAttribute("action");
    const props = {
      csrfTokenValue,
      path,
      validationSchema: JSON.parse(validationSchema),
      initialValues: JSON.parse(initialValues),
      userConfigName,
      configSelectPath,
      action
    }

    this.reactComponent.render(formTarget, props);
  }
  
  disconnect(){
    this.reactComponent.destroy(this.formTarget);
  }
}
